import Vue from 'vue';

export default {
  data() {
    return {
      loading: true,
      saving: false,
      clients: [],
      form: {
        client_id: null,
        name: '',
        valid_from: null,
        valid_to: null,
        is_active: true,
      },
    };
  },

  mounted() {
    Vue.$http.get('clients?basic_fields=1')
      .then(({ data }) => {
        this.clients = data.data || [];
        this.loading = false;
      })
      .catch(() => { this.loading = false; });
  },

  methods: {
    store() {
      if (!this.form.client_id || !this.form.name || !this.form.valid_from || !this.form.valid_to) {
        this.$message({ message: 'Please fill required fields', type: 'warning' });
        return;
      }
      this.saving = true;
      Vue.$http.post('pricing_agreements', this.form)
        .then(() => {
          this.$message({ message: 'Pricing agreement created', type: 'success' });
          this.$router.push({ name: 'pricingAgreements.index', query: { filter: 'active' } });
        })
        .catch((err) => {
          this.saving = false;
          const data = err.response && err.response.data ? err.response.data : null;
          let msg = null;
          let validationField = null;
          if (data && data.error && data.error.message) {
            msg = data.error.message;
          } else if (data && data.message) {
            msg = data.message;
          } else if (data && data.errors && typeof data.errors === 'object') {
            const keys = Object.keys(data.errors);
            if (keys.length && Array.isArray(data.errors[keys[0]]) && data.errors[keys[0]][0]) {
              validationField = keys[0];
              msg = data.errors[keys[0]][0];
            }
          } else if (data && typeof data === 'object') {
            const key = Object.keys(data).find((k) => Array.isArray(data[k]) && data[k][0]);
            if (key) {
              validationField = key;
              msg = data[key][0];
            }
          }
          if (validationField === 'name' && msg) {
            msg = this.$t('pricingAgreements.validationNameAlreadyExists');
          }
          this.$message({ message: msg || this.$t('pricingAgreements.errorCreatingAgreement'), type: 'error' });
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/pricingAgreements/create/create.js